import Button from '@doordash/component-button'
import { Text, StackChildren, Colors, Inline } from '@doordash/design-language'
import { pageLoad, Steps } from '../../../utilities/steps'
import * as React from 'react'
import scheduleOrientationStrings from './strings'

type ScheduleOrientationStepProps = {
  uniqueLink?: string
  isStepCompleted?: boolean
}

const ScheduleOrientationStep: React.FC<ScheduleOrientationStepProps> = ({
  uniqueLink,
  isStepCompleted,
}) => (
  <StackChildren>
    <Text color={Colors.SystemGrey80}>
      {scheduleOrientationStrings.progressionCheckScheduleOrientationDescription()}
    </Text>
    <div>
      <Inline tag={'span'} size={Inline.Sizes.XxSmall}>
        <Button
          type={Button.Types.PrimaryPill}
          size={Button.Sizes.Small}
          tag="a"
          onClick={() => {
            pageLoad(uniqueLink, isStepCompleted ? Steps.Reschedule : Steps.Orientation)
          }}
          isInline
        >
          {isStepCompleted ? scheduleOrientationStrings.scheduleOrientationDetails__reschedule() : scheduleOrientationStrings.progressionCheckScheduleOrientationButtonText()}
        </Button>
      </Inline>
    </div>
  </StackChildren>
)

export default ScheduleOrientationStep
